// Types
import { LeadStateType } from './States';

export const paginationState = {
    number: 0, // current page
    size: 0, // current page size or length of entries
    totalElements: 0, // all entries
    totalPages: 0, // all pages
};
export type PaginationInfoType = typeof paginationState;

export const itemState = {};
export type LeadsListItemType = typeof itemState;

export type LeadsForViewType = {
    page: PaginationInfoType;
    list: Array<LeadsListItemType>;
};

export type LeadsCallQueryParamsType = {
    status?: string | Array<string> | undefined;
    leadSource?: string | undefined;
    sort?: Array<Array<string> | undefined>;
    leadRateLimitExceeded?: boolean;
    page: number;
    size?: number;
};

export const leadsRawState = {
    _embedded: {
        leadViewList: [],
    },
    _links: {},

    page: paginationState,
};
export type LeadsRaw = {
    _embedded: {
        leadViewList: Array<LeadsListItemType> | [];
    };
    _links: any;

    page: PaginationInfoType;
};

export type LeadTabId = 'workflowTodos' | 'workflowOpen' | 'allLeads';
